'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_ENTITY_FETCHED = exports.EVENT_APP_FETCHED = exports.EVENT_ENTITY_CHANGED = exports.EVENT_APP_CHANGED = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Storage/Events module.
 * @module Storage/events
 */

/**
 * @type {string}
 */
var EVENT_APP_CHANGED = exports.EVENT_APP_CHANGED = 'storage.app.changed';

/**
 * @type {string}
 */
var EVENT_ENTITY_CHANGED = exports.EVENT_ENTITY_CHANGED = 'storage.entity.changed';

/**
 * @type {string}
 */
var EVENT_APP_FETCHED = exports.EVENT_APP_FETCHED = 'storage.app.fetched';

/**
 * @type {string}
 */
var EVENT_ENTITY_FETCHED = exports.EVENT_ENTITY_FETCHED = 'storage.entity.fetched';

/**
 * @readonly
 * @enum {string}
 * @type {{EVENT_APP_CHANGED: string, EVENT_ENTITY_CHANGED: string, EVENT_APP_FETCHED: string, EVENT_ENTITY_FETCHED: string}}
 */
var events = {
  EVENT_APP_CHANGED: EVENT_APP_CHANGED,
  EVENT_ENTITY_CHANGED: EVENT_ENTITY_CHANGED,
  EVENT_APP_FETCHED: EVENT_APP_FETCHED,
  EVENT_ENTITY_FETCHED: EVENT_ENTITY_FETCHED
};

/**
 * @constant
 *
 * @type {{}}
 */
var props = exports.props = events;

/**
 * @constant
 *
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/events.js
// module id = 158
// module chunks = 0